import { useEffect, useRef } from "react";
import Button from "./Button";
import SegmentedControl from "./SegmentedControl";

/*
  A screen's view switcher. From tablet up it's Figma's segmented control; on a
  phone the labels don't fit, so it's the frames' "Filter chips (scroll)": a
  sideways row of Size S buttons, tinted when selected.
*/
const ViewTabs = ({ options, value, onChange, label, selectedClass, className = "" }) => {
  const chipsRef = useRef(null);

  // A chip selected by the URL can start past the edge of the row.
  useEffect(() => {
    const row = chipsRef.current;
    const chip = row?.querySelector('[aria-selected="true"]');
    if (!chip || row.scrollWidth <= row.clientWidth) return;
    const box = row.getBoundingClientRect();
    const seg = chip.getBoundingClientRect();
    if (seg.left < box.left) row.scrollLeft -= box.left - seg.left;
    else if (seg.right > box.right) row.scrollLeft += seg.right - box.right;
  }, [value]);

  return (
    <>
      <SegmentedControl
        track="material"
        label={label}
        value={value}
        onChange={onChange}
        options={options}
        selectedClass={selectedClass}
        className={`hidden min-[600px]:flex ${className}`}
      />
      <div ref={chipsRef} role="tablist" aria-label={label} className="scrollbar-hide flex min-w-0 flex-1 gap-space-8 overflow-x-auto min-[600px]:hidden">
        {options.map((option) => {
          const selected = option.value === value;
          return (
            <Button
              key={option.value}
              role="tab"
              aria-selected={selected}
              size="s"
              variant={selected ? "tinted" : "gray"}
              onClick={() => !selected && onChange(option.value)}
              className="shrink-0 whitespace-nowrap"
            >
              {option.label}
            </Button>
          );
        })}
      </div>
    </>
  );
};

export default ViewTabs;
